import React, { useState, useEffect, useRef } from 'react';
import './Management.css';
import ManagementTableSkeleton from './Components/ManagementTableSkeleton';
import {
   Table, Space, Tooltip, Button, Select, Input, Row, Col, Tag,
   Modal, Typography, Spin,
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import * as AntDIcons from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
// import SideCalendar from '../../components/side-calendar/SideCalendar';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
// import { Levels } from '../../constants';

import { StudentEdit } from './Components/StudentEdit';
import { StudentAdd } from './Components/StudentAdd';
import { StudentImport } from './Components/StudentImport';
import { StudentEmergencyInfo } from '../EmergencyInfoPage/StudentEmergencyInfo';
import * as XLSX from 'xlsx';
import FolderUploadV2 from './Tools/FolderUploadV2';

const { Option } = Select;
const { Text, Paragraph } = Typography;

var studentID = null;

export function StudentInfo() {
   const navigate = useNavigate();
   const studentAddFormRef = useRef(null);
   const studentEditFormRef = useRef(null);

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [levelList, setLevelList] = useState([]);

   // const [studentID, setStudentID] = useState(null);
   const [level, setLevel] = useState(null);
   const [section, setSection] = useState([]);
   const [sectionList, setSectionList] = useState([]);
   const [studentList, setStudentList] = useState([]);
   const [studentCredentialsList, setStudentCredentialsList] = useState([]);
   const [studentForSectionChangeList, setStudentForSectionChangeList] = useState([]);

   const [sectionLoading, setSectionLoading] = useState(false);
   const [searchLoading, setSearchLoading] = useState(false);
   const [credsListLoading, setCredsListLoading] = useState(false);

   const [updating, setUpdating] = useState(false);
   const [editModalVisible, setEditModalVisible] = useState(false);
   const [addModalVisible, setAddModalVisible] = useState(false);
   const [importModalVisible, setImportModalVisible] = useState(false);
   const [credentialsModalVisible, setCredentialsModalVisible] = useState(false);
   const [emergencyInfoModalVisible, setEmergencyInfoModalVisible] = useState(false);

   const [studentsForSectionChange, setStudentsForSectionChange] = useState(null);
   const [sectionChangeModalVisible, setSectionChangeModalVisible] = useState(false);
   const [addToSectionModalVisible, setAddToSectionModalVisible] = useState(false);

   const [newSection, setNewSection] = useState([]);
   const [newSectionList, setNewSectionList] = useState([]);
   const [previewMode, setPreviewMode] = useState({});

   const [selectedStudent, setSelectedStudent] = useState(null);

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   useEffect(() => {
      Utils.verifyJwt();

      const allowedRoles = ['super admin', 'admin', 'teacher'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      getLevels();
   }, []);

   const getLevels = () => {
      axios.get(`${process.env.REACT_APP_API_LOOKUP}/levellist`).then((response) => {
         if (response.data) {
            const data = response.data;
            var tmp_levels = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               tmp_levels.push(obj);
            });

            setLevelList(tmp_levels);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<AntDIcons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <AntDIcons.SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const columns = [
      {
         title: '',
         dataIndex: 'id',
         key: 'id',
         hidden: true,
      },
      {
         title: 'Last Name',
         key: 'last_name',
         // dataIndex: 'last_name',
         sorter: (a, b) => { return a.last_name.localeCompare(b.last_name) },
         ...getColumnSearchProps('last_name'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="right" title={payload.last_name}>
               <span style={{ cursor: "default" }}>
                  {
                     payload.last_name !== null
                        ?
                        payload.last_name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </span>
            </Tooltip>
         ),
         width: '20%'
      },
      {
         title: 'First Name',
         key: 'first_name',
         // dataIndex: 'first_name',
         sorter: (a, b) => { return a.first_name.localeCompare(b.first_name) },
         ...getColumnSearchProps('firstname'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="right" title={payload.first_name}>
               <span style={{ cursor: "default" }}>
                  {
                     payload.first_name !== null
                        ?
                        payload.first_name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </span>
            </Tooltip>
         ),
         width: '20%'
      },
      {
         title: 'Gender',
         key: 'gender',
         ...getColumnSearchProps('gender'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.gender}>
               <Text>
                  {
                     payload.gender !== null
                        ?
                        payload.gender.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </Text>
            </Tooltip>
         ),
         width: '10%'
      },
      {
         title: 'Date of Birth',
         key: 'date_of_birth',
         dataIndex: 'date_of_birth',
         sorter: (a, b) => { return (a.date_of_birth === null ? '' : a.date_of_birth).localeCompare(b.date_of_birth === null ? '' : b.date_of_birth) },
         width: '15%'
      },
      {
         title: 'Level',
         key: 'level',
         dataIndex: 'level',
         sorter: (a, b) => { return (a.level === null ? '' : a.level).localeCompare(b.level === null ? '' : b.level) },
         width: '15%'
      },
      {
         title: 'Section',
         key: 'section',
         dataIndex: 'section',
         sorter: (a, b) => { return (a.section === null ? '' : a.section).localeCompare(b.section === null ? '' : b.section) },
         width: '15%'
      },
      {
         title: 'Active',
         key: 'is_active',
         dataIndex: 'is_active',
         sorter: (a, b) => { return a.is_active.localeCompare(b.is_active) },
         render: is_active => (
            <Tag style={{ fontSize: 12 }} color={is_active === 'no' ? 'red' : 'green'}>
               {is_active.toUpperCase()}
            </Tag>
         ),
         width: '10%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return <>
               {
                  ['Super Admin', 'Admin', 'Teacher'].includes(user_role) &&
                  <Space size="small">
                     <Tooltip placement="top" title='Edit Profile'>
                        <AntDIcons.EditOutlined color='#033D89' style={{ cursor: 'pointer' }} onClick={() => handleEdit(payload.id)} />
                     </Tooltip>
                     {
                        payload.emergency_info !== null &&
                        <Tooltip placement="top" title='Emergency Information'>
                           <AntDIcons.EyeOutlined color='#033D89' style={{ cursor: 'pointer' }} onClick={() => handleViewEmergencyInfo(payload.id)} />
                        </Tooltip>
                     }

                  </Space>
               }
            </>
         },
         width: '10%'
      },
   ].filter(item => !item.hidden);

   const creds_columns = [
      {
         title: 'Last Name',
         key: 'last_name',
         // dataIndex: 'last_name',
         sorter: (a, b) => { return a.last_name.localeCompare(b.last_name) },
         ...getColumnSearchProps('last_name'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="right" title={payload.last_name}>
               <span style={{ cursor: "default" }}>
                  {
                     payload.last_name !== null
                        ?
                        payload.last_name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </span>
            </Tooltip>
         ),
         width: '11%'
      },
      {
         title: 'First Name',
         key: 'first_name',
         // dataIndex: 'first_name',
         sorter: (a, b) => { return a.first_name.localeCompare(b.first_name) },
         ...getColumnSearchProps('firstname'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="right" title={payload.first_name}>
               <span style={{ cursor: "default" }}>
                  {
                     payload.first_name !== null
                        ?
                        payload.first_name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </span>
            </Tooltip>
         ),
         width: '14%'
      },
      {
         title: 'Gender',
         key: 'gender',
         ...getColumnSearchProps('gender'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.gender}>
               <Text>
                  {
                     payload.gender !== null
                        ?
                        payload.gender.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </Text>
            </Tooltip>
         ),
         width: '6%'
      },
      {
         title: 'Level',
         key: 'level',
         dataIndex: 'level',
         sorter: (a, b) => { return (a.level === null ? '' : a.level).localeCompare(b.level === null ? '' : b.level) },
         width: '6%'
      },
      {
         title: 'Section',
         key: 'section',
         dataIndex: 'section',
         sorter: (a, b) => { return (a.section === null ? '' : a.section).localeCompare(b.section === null ? '' : b.section) },
         width: '6%'
      },
      {
         title: 'Student Username / Password',
         key: 'student_credentials',
         width: '12%',
         render: (record) => {
            const isVisible = previewMode[record.id]?.student;
            const username = record.student_username || '';
            const password = record.student_password || '';
            return (
               <div>
                  <div>{isVisible ? `${username} / ${password}` : `${'*'.repeat(username.length)} / ${'*'.repeat(password.length)}`}</div>
                  <Button shape='round' size="small" onClick={() => togglePreview(record.id, 'student')}>
                     {isVisible ? 'Hide' : 'Show'}
                  </Button>
               </div>
            );
         }
      },
      {
         title: 'Parent Username / Password',
         key: 'parent_credentials',
         width: '12%',
         render: (record) => {
            const isVisible = previewMode[record.id]?.parent;
            const username = record.parent_username || '';
            const password = record.parent_password || '';
            return (
               <div>
                  <div>{isVisible ? `${username} / ${password}` : `${'*'.repeat(username.length)} / ${'*'.repeat(password.length)}`}</div>
                  <Button shape='round' size="small" onClick={() => togglePreview(record.id, 'parent')}>
                     {isVisible ? 'Hide' : 'Show'}
                  </Button>
               </div>
            );
         }
      },
      {
         title: 'Email',
         key: 'email',
         ellipsis: {
            showTitle: false,
         },
         sorter: (a, b) => { return (a.email === null ? '' : a.email).localeCompare(b.email === null ? '' : b.email) },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.email}>
               <Text>
                  {payload.email}
               </Text>
            </Tooltip>
         ),
         width: '13%'
      },
      {
         title: 'Zoom Account',
         key: 'zoom_email',
         ellipsis: {
            showTitle: false,
         },
         sorter: (a, b) => { return (a.zoom_email === null ? '' : a.zoom_email).localeCompare(b.zoom_email === null ? '' : b.zoom_email) },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.zoom_email}>
               <Text>
                  {payload.zoom_email}
               </Text>
            </Tooltip>
         ),
         width: '10%'
      },
   ].filter(item => !item.hidden);

   const change_section_columns = [
      {
         title: 'ID',
         dataIndex: 'id',
         key: 'id',
         hidden: true,
      },
      {
         title: 'Last Name',
         key: 'last_name',
         // dataIndex: 'last_name',
         sorter: (a, b) => { return a.last_name.localeCompare(b.last_name) },
         ...getColumnSearchProps('last_name'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="right" title={payload.last_name}>
               <span style={{ cursor: "default" }}>
                  {
                     payload.last_name !== null
                        ?
                        payload.last_name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </span>
            </Tooltip>
         ),
         width: '30%'
      },
      {
         title: 'First Name',
         key: 'first_name',
         // dataIndex: 'first_name',
         sorter: (a, b) => { return a.first_name.localeCompare(b.first_name) },
         ...getColumnSearchProps('firstname'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="right" title={payload.first_name}>
               <span style={{ cursor: "default" }}>
                  {
                     payload.first_name !== null
                        ?
                        payload.first_name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
                        :
                        ''
                  }
               </span>
            </Tooltip>
         ),
         width: '30%'
      },
      // {
      //    title: 'Gender',
      //    key: 'gender',
      //    ...getColumnSearchProps('gender'),
      //    ellipsis: {
      //       showTitle: false,
      //    },
      //    render: payload => (
      //       <Tooltip placement="topLeft" title={payload.gender}>
      //          <Text>
      //             {
      //                payload.gender !== null
      //                   ?
      //                   payload.gender.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
      //                   :
      //                   ''
      //             }
      //          </Text>
      //       </Tooltip>
      //    ),
      //    width: '10%'
      // },
      // {
      //    title: 'Date of Birth',
      //    key: 'date_of_birth',
      //    dataIndex: 'date_of_birth',
      //    sorter: (a, b) => { return (a.date_of_birth === null ? '' : a.date_of_birth).localeCompare(b.date_of_birth === null ? '' : b.date_of_birth) },
      //    width: '15%'
      // },
      {
         title: 'Level',
         key: 'level',
         dataIndex: 'level',
         sorter: (a, b) => { return (a.level === null ? '' : a.level).localeCompare(b.level === null ? '' : b.level) },
         width: '15%'
      },
      {
         title: 'Section',
         key: 'section',
         dataIndex: 'section',
         sorter: (a, b) => { return (a.section === null ? '' : a.section).localeCompare(b.section === null ? '' : b.section) },
         width: '15%'
      },
      {
         title: 'Active',
         key: 'is_active',
         dataIndex: 'is_active',
         sorter: (a, b) => { return a.is_active.localeCompare(b.is_active) },
         render: is_active => (
            <Tag style={{ fontSize: 12 }} color={is_active === 'no' ? 'red' : 'green'}>
               {is_active.toUpperCase()}
            </Tag>
         ),
         width: '10%'
      },
   ].filter(item => !item.hidden);

   const handleLevelChange = (val) => {
      setSection(null)
      setSectionList([]);
      setNewSectionList([]);
      setLevel(val);
      setSectionLoading(true);

      axios.get(`${process.env.REACT_APP_API_LOOKUP}/sectionlistbylevel?level=${val}`).then((response) => {
         if (response.data) {
            const data = response.data;

            var sectionlist = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               sectionlist.push(obj);
            });

            setSectionList(sectionlist);
            setNewSectionList(sectionlist);
            setSectionLoading(false);
         }
      }, (error) => {
         setSectionLoading(false);
         console.log(error.message);
      });
   }

   const handleSectionChange = (val) => {
      setSection(val);
   }

   const handleGetStudentList = () => {
      setSearchLoading(true);
      setStudentList([]);

      axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/getstudentlist?level=${level}&section=${section}`).then((response) => {
         if (response.data) {
            const data = response.data;

            //--add key to the student list 
            for (var i = 0; i < data.length; i++) {
               data[i].key = data[i].id;
            }

            setStudentList(data);
            setStudentForSectionChangeList(data);
            setSearchLoading(false);
         }
      }, (error) => {
         setSearchLoading(false);
         console.log(error.message);
      });
   }

   const handleAddNewStudent = () => {
      setAddModalVisible(true);
   }

   const handleEdit = (id) => {
      // setStudentID(id);
      studentID = id;
      setEditModalVisible(true);
   }

   const handleSave = () => {
      handleGetStudentList();
      setUpdating(false);
      setEditModalVisible(false);
      setAddModalVisible(false);
   }

   const handleCancel = () => {
      setEditModalVisible(false);
      setAddModalVisible(false);
      setImportModalVisible(false);
      setCredentialsModalVisible(false);
      setSectionChangeModalVisible(false);
      setAddToSectionModalVisible(false);
      setPreviewMode({});
   }

   const handleAddModalCancel = () => {
      if (studentAddFormRef.current?.handleCancel) {
         studentAddFormRef.current.handleCancel();
         return;
      }

      handleCancel();
   }

   const handleEditModalCancel = () => {
      if (studentEditFormRef.current?.handleCancel) {
         studentEditFormRef.current.handleCancel();
         return;
      }

      handleCancel();
   }

   const togglePreview = (id, type) => {
      setPreviewMode(prev => {
         const newMode = { ...prev };

         // If showing, hide all other credentials first
         if (!prev[id]?.[type]) {
            // Hide all student credentials
            Object.keys(newMode).forEach(rowId => {
               if (newMode[rowId]) {
                  newMode[rowId] = { ...newMode[rowId], student: false, parent: false };
               }
            });
         }

         // Toggle the specific credential
         newMode[id] = {
            ...newMode[id],
            [type]: !prev[id]?.[type]
         };

         return newMode;
      });
   }

   const handleUpdating = () => {
      setUpdating(true);
   }

   const handleImportComplete = () => {
      setUpdating(false);
      setImportModalVisible(false);
   }

   const handleExportToExcel = () => {
      const worksheet = XLSX.utils.json_to_sheet(studentCredentialsList);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Student Credentials");
      //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
      //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workbook, "Brainee_Student_Info.xlsx");
   }

   // Export Emergency Info to Excel
   const handleExportEmergencyInfoToExcel = () => {
      // Filter students with emergency_info
      const filtered = studentList.filter(s => s.emergency_info !== null && s.emergency_info !== undefined && s.emergency_info !== "");
      if (filtered.length === 0) {
         Modal.info({
            title: "Export Emergency Info",
            content: "No students with emergency info to export.",
            centered: true,
         });
         return;
      }

      // Flatten emergency_info JSON for each student
      let rows = [];
      filtered.forEach(student => {
         let emergency = {};
         try {
            emergency = typeof student.emergency_info === "string"
               ? JSON.parse(student.emergency_info)
               : student.emergency_info;
         } catch (e) {
            emergency = { error: "Invalid JSON" };
         }
         // Merge student info and emergency info
         rows.push({
            "ID": student.id,
            // "Last Name": student.last_name,
            // "First Name": student.first_name,
            // "Level": student.level,
            // "Section": student.section,
            ...emergency
         });
      });

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Emergency Info");
      XLSX.writeFile(workbook, "Brainee_Student_Emergency_Info.xlsx");
   }

   const handleShowCredentials = () => {
      setStudentCredentialsList([]);
      setCredentialsModalVisible(true);
      setCredsListLoading(true);

      axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/getstudentinfoforexport?level=${level}&section=${section}`).then((response) => {
         if (response.data) {
            const data = response.data;

            setStudentCredentialsList(data);
            setCredsListLoading(false);
         }
      }, (error) => {
         setCredsListLoading(false);
         console.log(error.message);
      });
   }

   const handleShowChangeSection = () => {
      setNewSection(null);
      setStudentsForSectionChange([]);
      setSectionChangeModalVisible(true);
   }

   const handleChangeSection = () => {
      if (studentsForSectionChange.length > 0 && newSection !== null) {
         var selectedStudents = studentsForSectionChange.join(',');

         axios.post(`${process.env.REACT_APP_API_MANAGEMENT}/changesection?ids=${selectedStudents}&oldsection=${section}&newsection=${newSection}`).then((response) => {
            if (response.data) {
               const data = response.data;

               Modal.success({
                  title: 'Student Management',
                  content: 'Change of section successful.',
                  centered: true,
                  onOk: setSectionChangeModalVisible(false),
               });

               //-- Refresh student list
               handleGetStudentList();
            }
         }, (error) => {
            console.log(error.message);
            Modal.error({
               title: 'Student Management',
               content: error.response.data,
               centered: true,
               onOk: setSectionChangeModalVisible(false),
            });
         });
      }
      else {
         Modal.info({
            title: 'Student Management',
            content: <>
               <p>
                  Please supply the following parameters:
               </p>
               Students
               <br />
               New Section
            </>,
            centered: true,
         });
      }
   }

   const handleShowAddToSection = () => {
      setNewSection(null);
      setStudentsForSectionChange([]);
      setAddToSectionModalVisible(true);
   }

   const handleAddSection = () => {
      if (studentsForSectionChange.length > 0 && newSection !== null) {
         var selectedStudents = studentsForSectionChange.join(',');

         axios.post(`${process.env.REACT_APP_API_MANAGEMENT}/addtosection?ids=${selectedStudents}&level=${level}&newsection=${newSection}`).then((response) => {
            if (response.data) {
               const data = response.data;

               Modal.success({
                  title: 'Student Management',
                  content: 'Add to section successful.',
                  centered: true,
                  onOk: setAddToSectionModalVisible(false),
               });
            }
         }, (error) => {
            console.log(error.message);
            Modal.error({
               title: 'Student Management',
               content: error.response.data,
               centered: true,
               // onOk: setAddToSectionModalVisible(false),
            });
         });
      }
      else {
         Modal.info({
            title: 'Student Management',
            content: <>
               <p>
                  Please supply the following parameters:
               </p>
               Students
               <br />
               Section
            </>,
            centered: true,
         });
      }
   }

   const rowSelection = {
      selectedRowKeys: studentsForSectionChange,
      onChange: (selectedRowKeys, selectedRows) => {
         setStudentsForSectionChange(selectedRowKeys);
      },
   };

   const handleViewEmergencyInfo = (id) => {
      // var data = studentList.find(e => e.id === id);
      setSelectedStudent(id);
      setEmergencyInfoModalVisible(true);
   }

   return (
      <>
         <div className="dashboard-area-all management-page">
            <div className="dashboard-item management-shell">
               <div className="management-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'management', node: 'Management' },
                        { key: 'student-info', node: 'Student Information' },
                     ]}
                  />
               </div>

               <section className="management-hero">
                  <div>
                     <Text className="management-kicker">Management</Text>
                     <h1>Student Information</h1>
                     <p>Find, update, and organize student records by level and section.</p>
                     <div className="management-meta">
                        <span><AntDIcons.SolutionOutlined /> Student directory</span>
                        <span><AntDIcons.DatabaseOutlined /> {searchLoading ? 'Loading records' : `${studentList.length} records`}</span>
                     </div>
                  </div>
                  {
                     ['Super Admin'].includes(user_role) &&
                     <div className="management-actions">
                        <Space wrap>
                           <Button className='management-create-btn button-shadow' type="primary" size="large" shape='round' onClick={() => handleAddNewStudent()}>
                              <AntDIcons.UserAddOutlined /> Add New Student
                           </Button>
                           <Button className='management-create-btn button-shadow' type="primary" size="large" shape='round' onClick={() => setImportModalVisible(true)}>
                              <AntDIcons.UsergroupAddOutlined /> Import New Students
                           </Button>
                           {<FolderUploadV2 />}
                        </Space>
                     </div>
                  }
               </section>

               <section className="management-panel">
                  <div className='management-filter-row'>
                     <Select
                        showArrow
                        size='middle'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select Level"
                        onChange={(val) => handleLevelChange(val)}
                        value={level}
                     >
                        {levelList.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>

                     <Select
                        loading={sectionLoading}
                        showArrow
                        size='middle'
                        style={{ width: '100%' }}
                        allowClear
                        placeholder="Select Section"
                        value={section}
                        onChange={(val) => handleSectionChange(val)}
                     >
                        <Option value={-1}>All</Option>
                        {sectionList.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>

                     <Button className='button-shadow' type='primary' shape='round' block onClick={() => handleGetStudentList()} icon={<AntDIcons.SearchOutlined />}>Search</Button>
                  </div>

            {
               (studentList.length > 0 && ['Super Admin', 'Admin', 'Teacher'].includes(user_role)) &&
               <div className="management-action-row">
                  <div className="management-action-group">
                        {
                           ['super admin', 'admin', 'teacher'].includes(user_role.toLowerCase()) &&
                           <Button className='button-shadow' type='primary' shape='round' onClick={() => handleShowCredentials()}>Show Credentials</Button>
                        }
                        {
                           ['Super Admin'].includes(user_role) &&
                           <>
                              <Button className='button-shadow' type='primary' shape='round' onClick={() => handleShowChangeSection()}>Change Section</Button>
                              <Button className='button-shadow' type='primary' shape='round' onClick={() => handleShowAddToSection()}>Add To Section</Button>
                           </>
                        }
                  </div>
                  <div className="management-action-group">
                     {
                        ['super admin', 'admin', 'teacher'].includes(user_role.toLowerCase()) &&
                        <Button className='button-shadow' type='primary' shape='round' onClick={handleExportEmergencyInfoToExcel}>Export Emergency Info to Excel</Button>
                     }
                  </div>
               </div>
            }

                  <div className="management-table-shell">
                     {
                        !searchLoading
                           ?
                           <Table
                              className="management-table"
                              rowKey={'student-list'}
                              // loading={searchLoading}
                              size='small'
                              columns={columns}
                              dataSource={studentList}
                              pagination={false}
                              scroll={{
                                 y: 'calc(100svh - 18rem)',
                                 x: '1000px'
                              }}
                              footer={() => <div className="management-table-footer"><span>Total Records: {studentList.length}</span></div>}
                           />
                           :
                           <ManagementTableSkeleton />
                     }
                  </div>
               </section>
            </div>
         </div>

         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}

         {/* Modals */}

         <Modal
            className="management-modal management-student-modal"
            title={"Add New Student"}
            centered
            destroyOnClose={true}
            onCancel={handleAddModalCancel}
            open={addModalVisible}
            width='75%'
            footer={[
               <Button key="cancel" shape='round' onClick={handleAddModalCancel}>Cancel</Button>,
               <Button key="save" type='primary' shape='round' htmlType='submit' form="student-add-form">Save</Button>
            ]}
         >
            <StudentAdd
               ref={studentAddFormRef}
               onUpdatingCallBack={handleUpdating}
               onSaveCompleteCallBack={handleSave}
               onCancelCallback={handleCancel}
               onUpdatingFailCallback={() => setUpdating(false)}
            />
         </Modal>

         <Modal
            className="management-modal management-student-modal"
            title={"Edit Student Information"}
            centered
            destroyOnClose={true}
            onCancel={handleEditModalCancel}
            open={editModalVisible}
            width='75%'
            footer={[
               <Button key="cancel" shape='round' onClick={handleEditModalCancel}>Cancel</Button>,
               <Button key="save" type='primary' shape='round' htmlType='submit' form="student-edit-form">Save</Button>
            ]}
         >
            <Spin spinning={updating} tip={"Processing, please wait..."}>
               <StudentEdit
                  ref={studentEditFormRef}
                  studentID={studentID}
                  onUpdatingCallBack={handleUpdating}
                  onSaveCompleteCallBack={handleSave}
                  onCancelCallback={handleCancel}
                  onUpdatingFailCallback={() => setUpdating(false)}
               />
            </Spin>
         </Modal>

         <Modal
            className="management-modal"
            title={"Import New Students"}
            centered
            destroyOnClose={true}
            onCancel={() => { setImportModalVisible(false); }}
            open={importModalVisible}
            // footer={null}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
            okText={'Import'}
         >
            <Spin spinning={updating} tip={"Processing, please wait..."}>
               <StudentImport
                  onUpdatingCallBack={handleUpdating}
                  onSaveCompleteCallBack={handleImportComplete}
                  onCancelCallback={handleCancel}
                  onUpdatingFailCallback={() => setUpdating(false)}
               />
            </Spin>
         </Modal>

         <Modal
            className="management-modal"
            title={"Student Credentials"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancel(); }}
            onOk={() => handleExportToExcel()}
            open={credentialsModalVisible}
            width='85%'
            okButtonProps={{ shape: 'round', type: 'primary', hidden: user_role === 'Super Admin' ? false : true }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Export'}
            cancelText={'Close'}
         >
            <Table
               rowKey={'uid'}
               loading={credsListLoading}
               size='small'
               columns={creds_columns}
               dataSource={studentCredentialsList}
               pagination={false}
               scroll={{
                  y: 'calc(100svh - 20rem)',
                  x: '1500px'
               }}
            />
         </Modal>

         <Modal
            className="management-modal"
            title={"Change Section"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancel(); }}
            onOk={() => handleChangeSection()}
            open={sectionChangeModalVisible}
            width='70%'
            okButtonProps={{ shape: 'round', type: 'primary' }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Change'}
            cancelText={'Close'}
         >
            <Row gutter={12} style={{ marginBottom: '15px' }} >
               <Col span={24}>
                  <Table
                     rowSelection={rowSelection}
                     size='small'
                     columns={change_section_columns}
                     dataSource={studentForSectionChangeList}
                     pagination={false}
                     scroll={{
                        y: 'calc(100svh - 22rem)',
                        x: '800px'
                     }}
                  />
               </Col>
            </Row>

            <Row gutter={12}>
               <Col span={24} style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                     <Text>Change To</Text>
                     <Select
                        showArrow
                        size='middle'
                        style={{ width: '300px' }}
                        allowClear
                        placeholder="Select New Section"
                        value={newSection}
                        onChange={(val) => setNewSection(val)}
                     >
                        <Option value={-1}>All</Option>
                        {newSectionList.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>
                  </Space>
               </Col>
            </Row>
         </Modal>

         <Modal
            className="management-modal"
            title={"Add To Section"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancel(); }}
            onOk={() => handleAddSection()}
            open={addToSectionModalVisible}
            width='70%'
            okButtonProps={{ shape: 'round', type: 'primary' }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Add'}
            cancelText={'Close'}
         >
            <Row gutter={12} style={{ marginBottom: '15px' }} >
               <Col span={24}>
                  <Table
                     rowSelection={rowSelection}
                     size='small'
                     columns={change_section_columns}
                     dataSource={studentForSectionChangeList}
                     pagination={false}
                     scroll={{
                        y: 'calc(100svh - 22rem)',
                        x: '800px'
                     }}
                  />
               </Col>
            </Row>

            <Row gutter={12}>
               <Col span={24} style={{ display: "flex", justifyContent: "right" }}>
                  <Space>
                     <Text>Add To</Text>
                     <Select
                        showArrow
                        size='middle'
                        style={{ width: '300px' }}
                        allowClear
                        placeholder="Select Section"
                        value={newSection}
                        onChange={(val) => setNewSection(val)}
                     >
                        <Option value={-1}>All</Option>
                        {newSectionList.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>
                        })}
                     </Select>
                  </Space>
               </Col>
            </Row>
         </Modal>

         <Modal
            className="management-modal"
            title="Student Emergency Information"
            centered
            destroyOnClose={true}
            onCancel={() => { setEmergencyInfoModalVisible(false); }}
            open={emergencyInfoModalVisible}
            width='75%'
            okButtonProps={{ style: { display: 'none' } }}
            cancelText="Close"
            style={{ height: 'Calc(100vh - 50px)', top: 0, paddingBottom: 0 }}
            bodyStyle={{ overflowY: 'auto', maxHeight: 'calc(100vh - 170px)' }}
         >
            <StudentEmergencyInfo
               // data={studentList.find(e => e.id === selectedStudent)}
               mode='view'
               student_id={selectedStudent}
            />
         </Modal>
      </>
   );
}
